import React, { useEffect, useState } from 'react';
import { RecordSection } from '../../components/PersonInterviewPanels';
import YoungApprenticeService from '../../services/YoungApprenticeService';

export default function WorldOfWorkRegistration({ form, setForm }) {
  const [catalog, setCatalog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let mounted = true;
    YoungApprenticeService.listLookup('terminationReason')
      .then(rows => { if (mounted) setCatalog(Array.isArray(rows) ? rows.filter(row => row.status === 'ACTIVE').map(row => row.name) : []); })
      .catch(() => { if (mounted) setError('Não foi possível carregar os motivos de encerramento cadastrados.'); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);
  const record = form.customFields?.worldOfWorkRecord || {};
  const set = (key, value) => setForm(current => ({ ...current, customFields: { ...(current.customFields || {}), worldOfWorkRecord: { ...(current.customFields?.worldOfWorkRecord || {}), [key]: value } } }));
  const reasons = [...new Set([...catalog, record.exitReason].filter(Boolean))];
  return <RecordSection title="Registro MT" icon="registration">
    <div className="record-editor__field-grid">
      <label className="record-profile__field--enrollmentDate"><span>Data de inscrição</span><input type="date" value={record.enrollmentDate || ''} onChange={event => set('enrollmentDate', event.target.value)} /></label>
      <label className="record-profile__field--observations"><span>Observações</span><input value={record.observations || ''} onChange={event => set('observations', event.target.value)} /></label>
      <label className="record-profile__field--exitDate"><span>Data de saída</span><input type="date" value={record.exitDate || ''} onChange={event => set('exitDate', event.target.value)} /></label>
      <label className="record-profile__field--exitReason"><span>Motivo de Encerramento</span><select value={record.exitReason || ''} disabled={loading} aria-busy={loading} onChange={event => set('exitReason', event.target.value)}><option value="">{loading ? 'Carregando motivos...' : 'Selecione'}</option>{reasons.map(reason => <option key={reason} value={reason}>{reason}</option>)}</select></label>
    </div>
    {error && <small role="alert">{error}</small>}
  </RecordSection>;
}
